import AppConfig from '@config';
import { useAppContext, useAppStore } from '@store';
import { useState } from 'react';
import { View } from 'react-native';
import ChekinWidget from '../chekin/ChekinWidget';
import { Spacer } from '../components';
import { ButtonView } from './Common';
import { LoginStyles } from './Styles';

export const Chekin = () => {
  const { company, reservation } = useAppStore();
  const { isChekinRequired, isChekinLoading, startChekinStatusPolling } =
    useAppContext();

  const [isNextButtonDisabled, setIsNextButtonDisabled] = useState(
    isChekinLoading || isChekinRequired,
  );
  const handleGuestRegistered = () => {
    setIsNextButtonDisabled(false);
  };
  const handleNext = async () => {
    startChekinStatusPolling();
    return true;
  };

  return (
    <View style={[AppConfig.Styles.container, AppConfig.Styles.center]}>
      <View style={[AppConfig.Styles.container, LoginStyles.container]}>
        <View style={[LoginStyles.contentContainer]}>
          <View style={{ width: '100%', height: '100%' }}>
            {company?.id && reservation?.id && (
              <ChekinWidget
                companyId={company.id}
                pmsReservationId={reservation?.id}
                onGuestRegistered={handleGuestRegistered}
              />
            )}
          </View>
        </View>
        <Spacer />
        <ButtonView
          company={company}
          currentPage="Chekin"
          disabled={isNextButtonDisabled}
          loading={isChekinLoading}
          onSubmit={handleNext}
        />
      </View>
    </View>
  );
};

export default Chekin;
